import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.css'
import styles from './page.module.css'
import './App.css';

function App() {
  return (
    <>
    {/* <div className={styles.description}>
        <p>
          Your software solutions provider
        </p>
        <div>
          <a
            href="/"
            rel="noopener noreferrer"
          >
            By BIM
          </a>
        </div>
      </div> */}
<div  className={styles.main}>
      <div className={styles.center}>
        <img
          className={styles.logo}
          src="logo.png"
          alt="Logo"
          width={256}
          height={100}
          priority
        />
      </div>

      <div className={styles.grid}>
        <a
          href="/build"
          className={styles.card}
          rel="noopener noreferrer"
        >
          <h2>
            Build <span>-&gt;</span>
          </h2>
          <img
            className={styles.logo}
            src="build.jpg"
            alt="Logo"
            width={72}
            height={72}
            priority
          />
          <p>Build Web, Mobile  and Cloud apps</p>
        </a>

        <a
          href="/integrate"
          className={styles.card}
          rel="noopener noreferrer"
        >
          <h2>
            Integrate <span>-&gt;</span>
          </h2>
          <img
            className={styles.logo}
            src="integrate.jpg"
            alt="Logo"
            width={72}
            height={72}
            priority
          />
          <p>Integrate your apps with each other and third party apps </p>
        </a>

        <a
          href="/manage"
          className={styles.card}
          rel="noopener noreferrer"
        >
          <h2>
            Manage <span>-&gt;</span>
          </h2>
          <img
            className={styles.logo}
            src="manage.jpg"
            alt="Logo"
            width={72}
            height={72}
            priority
          />

          <p>Manage your apps on aws, azure or gcp</p>
        </a>

      </div>
      </div>
      </>
  );
}

export default App;
